import { useEffect } from 'react'

// Scroll and reveal animations for the single-page website.
// CSS classes control how things look; this file only decides WHEN they play.
export function usePageEffects() {
  useEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const frame = requestAnimationFrame(() => {
      document.body.classList.add('motion-loaded')
    })

    if (reducedMotion) {
      document.querySelectorAll('main > section, .motion-item').forEach((el) => {
        el.classList.add('revealed', 'motion-in')
      })
      return () => cancelAnimationFrame(frame)
    }

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed')
            sectionObserver.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.08, rootMargin: '0px 0px 18% 0px' }
    )

    const sections = document.querySelectorAll(
      'main > section:not(.hero):not(.story-motion)'
    )
    sections.forEach((section) => {
      section.classList.add('reveal-ready')
      sectionObserver.observe(section)
    })

    const itemObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('motion-in')
            itemObserver.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1, rootMargin: '0px 0px 12% 0px' }
    )

    const items = document.querySelectorAll(
      '.country-card, .cap, .expertise-panel, .strategy-card, .placement-item, .profile-card, .insight, .step, .value-card, .market, .faq-list details, .stat'
    )

    const groups = new Map()
    items.forEach((item) => {
      item.classList.add('motion-item')
      const parent = item.parentElement
      if (!groups.has(parent)) {
        groups.set(parent, [])
      }
      groups.get(parent).push(item)
    })

    groups.forEach((group) => {
      group.forEach((item, index) => {
        item.style.transitionDelay = `${index * 85}ms`
        itemObserver.observe(item)
      })
    })

    function revealSection(section) {
      if (!section) {
        return
      }
      section.classList.add('revealed')
      section.querySelectorAll('.motion-item').forEach((item) => {
        item.classList.add('motion-in')
      })
    }

    function revealFromHash() {
      const id = window.location.hash.replace('#', '')
      if (!id || id === 'top') {
        return
      }
      revealSection(document.getElementById(id))
    }

    const safety = window.setTimeout(() => {
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top < window.innerHeight * 0.92) {
          revealSection(section)
        }
      })
      revealFromHash()
    }, 180)

    window.addEventListener('hashchange', revealFromHash)

    return () => {
      cancelAnimationFrame(frame)
      window.clearTimeout(safety)
      window.removeEventListener('hashchange', revealFromHash)
      sectionObserver.disconnect()
      itemObserver.disconnect()
    }
  }, [])
}
